module.exports = __webpack_public_path__ + "assets/img/0d13-vc.svg";